var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-context-header",class:{ 'with-action': _vm.useBackAction }},[(_vm.useBackAction)?_c('KIconButton',{attrs:{"icon":"back","aria-label":_vm.backLabel,"title":_vm.backLabel},on:{"click":_vm.backAction}}):_vm._e(),_c('h2',[_vm._v("\n    "+_vm._s(_vm.title || _vm.selectedFacility.name)+"\n  ")])],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }